export default __webpack_public_path__ + "static/media/cl.d49e5303.svg";